import {
  Button,
  Typography,
  TypographyMods,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';

import { Image } from '~components/Image/Image';
import { InvisibleAnchor } from '~components/InvisibleAnchor';

import styles from './FooterCommon.module.scss';
import type { FooterProps } from './FooterCommon.types';
import { FooterLogo } from './FooterLogo/FooterLogo';

// TODO: этот компонент скопирован из mark-ui и требует дальнейшей замены на компонент из mark-ui

export function FooterCommon({
  logo,
  additionalButtons,
  columns,
  endorsementLogo,
  socials,
  texts,
  id,
}: FooterProps) {
  return (
    <footer className={styles.footer}>
      {id && <InvisibleAnchor id={id} />}
      <div className={styles.bg}>
        {(logo || (additionalButtons && additionalButtons?.length > 0)) && (
          <>
            <div className={styles.footerTop}>
              {logo && <FooterLogo {...logo} />}
              <div style={{ display: 'flex', gap: '12px' }}>
                {additionalButtons?.map(
                  (button, key) =>
                    button && (
                      <Button
                        key={button.id || key}
                        {...button}
                        icon={button.icon && <Image {...button.icon} />}
                      />
                    ),
                )}
              </div>
            </div>
            <div className={styles.line}></div>
          </>
        )}
        {columns && (
          <>
            <div
              className={classNames(styles.footerBody, {
                [styles.justifyLeft]: columns.length < 3,
              })}
            >
              {columns.map((column) => (
                <nav key={column.id} className={styles.column}>
                  {column.sections.map((section) => (
                    <div key={section.id}>
                      {section.href ? (
                        <a
                          target="_blank"
                          className={styles.sectionLink}
                          href={section.href}
                        >
                          <Typography mods={[TypographyMods.titleM]}>
                            {section.title}
                          </Typography>
                        </a>
                      ) : (
                        <Typography mods={[TypographyMods.titleM]}>
                          {section.title}
                        </Typography>
                      )}
                      {section.items && section.items.length > 0 && (
                        <ul className={styles.list}>
                          {section.items.map((columnItem) => (
                            <li className={styles.listItem} key={columnItem.id}>
                              {columnItem.url ? (
                                <a
                                  target="_blank"
                                  className={classNames(
                                    styles.link,
                                    columnItem.is_highlight && styles.highlight,
                                  )}
                                  href={columnItem.url}
                                >
                                  <Typography mods={[TypographyMods.bodyS]}>
                                    {columnItem.title}
                                  </Typography>
                                </a>
                              ) : (
                                <Typography mods={[TypographyMods.bodyS]}>
                                  {columnItem.title}
                                </Typography>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </nav>
              ))}
            </div>
            <div className={styles.line}></div>
          </>
        )}
        <div
          className={classNames(styles.footerBottom, {
            [styles.noSocials]: !socials,
            [styles.noEndorsement]: !endorsementLogo,
          })}
        >
          {endorsementLogo && (
            <div className={styles.endorsement}>
              <Image {...endorsementLogo} />
            </div>
          )}
          {socials && (
            <div className={styles.socials}>
              {socials.map(
                (item) =>
                  item.href &&
                  item.logo && (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      key={item.id}
                    >
                      <Image className={styles.socialLink} {...item.logo} />
                    </a>
                  ),
              )}
            </div>
          )}
          {texts &&
            texts.map((item, index) => (
              <div
                className={classNames(
                  styles.footerText,
                  styles[`footerText${index + 1}`],
                )}
                key={item.id}
              >
                {item.href ? (
                  <a
                    target="_blank"
                    href={item.href}
                    className={styles.textLink}
                  >
                    {item.text}
                  </a>
                ) : (
                  <Typography
                    mods={[TypographyMods.captionM]}
                    className={styles.text}
                  >
                    {item.text}
                  </Typography>
                )}
              </div>
            ))}
        </div>
      </div>
    </footer>
  );
}
